import { joinServiceUrl } from "@/api/servicePaths";
import { API_BASEURL } from "@/configs";

export const resolveMediaUrl = (urlOrPath?: string | null): string | undefined => {
  const raw = (urlOrPath || "").trim();
  if (!raw) return undefined;

  const noTrailingSlash = raw.replace(/\/$/, "");
  if (/^https?:\/\//i.test(noTrailingSlash)) return noTrailingSlash;

  const base = (API_BASEURL || "").trim();
  if (!base) return noTrailingSlash;

  return joinServiceUrl(base, noTrailingSlash);
};
